module.exports = __webpack_public_path__ + "img/construction_thumbnail.b29360ac.jpg";